import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import IfSocialLinksAvailable from '../../../components/behavior/IfSocialLinksAvailable';
import { Column, Row } from '../../../components/Grid';
import { Section } from '../../../components/Section';
import {
  SocialContainer,
  SocialText
} from '../../../components/SocialMedia';
import { Hint } from '../../../components/Text';
import SocialLinksContainer from '../../SocialLinksContainer'
import {
  PAGE_DETAIL,
  PAGE_SEARCH
} from '../../../provider/Typo3Provider/config/t3PageMapping';
import {
  selectMeta
} from '../../../provider/Typo3Provider/selectors';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';
import { withFootnote, WithFootnoteProps } from '../../../provider/FootnoteProvider/withFootnote';

interface SocialMediaContainerProps {}

class SocialMediaContainer extends Component<
  SocialMediaContainerProps & WithTypo3Props & WithFootnoteProps & RouteComponentProps
> {
  public render() {
    const meta = selectMeta(this.props.typo3);

    if (meta) {
      // FIXME: bitte double-quotes ohne curly brackets nutzen, wenn strings als props
      // übergeben werden sollen
      // `className={'hide-for-print}` -> `className="hide-for-print"`
      return (
        <Row noGap borderTop className={'hide-for-print'}>
          <Column>
            <Section noPadding>
              <Row justifyContent="right">
                <Column large={7} small={12}>
                  {/* TODO: use Route instead of static page IDs, configs/typoPageMapping.js */}
                  {[PAGE_DETAIL, PAGE_SEARCH].includes(meta.page.uid) && (
                    <Hint>
                      * <Typo3Label label="service.currencyHint" />
                    </Hint>
                  )}

                  {this.props.footnote.footnotes.map((footnote, index) => <Hint key={index}>{footnote}</Hint>)}

                  {meta.sys_language_isocode === 'fr' && (
                    // TODO: labels
                    <Hint>
                      ¹ Autobus/autocars d’occasion par Mercedes-Benz et Setra
                    </Hint>
                  )}
                </Column>

                <Column large={5} small={12}>
                  <IfSocialLinksAvailable>
                    <SocialContainer className="hide-for-print">
                      <SocialText>
                        <Typo3Label label="service.socialMedia.share" />
                      </SocialText>
                      <SocialLinksContainer type={'content'}></SocialLinksContainer>
                    </SocialContainer>
                  </IfSocialLinksAvailable>
                </Column>
              </Row>
            </Section>
          </Column>
        </Row>
      );
    }

    return null;
  }
}

export default withRouter(withTypo3(withFootnote(SocialMediaContainer)));
